import React from "react";
import Card from  'src/components/Card/Card';
import CardBody from  'src/components/Card/CardBody';
import Danger from 'src/components/Typography/Danger.jsx';

export const Error = () => (
    <Card>
        <CardBody>
            <Danger className='error-container'>
                <h1>Sorry, something went wrong.</h1>
            </Danger>
        </CardBody>
    </Card>    
);

export default Error;
